{
  "loadError": "Could not load the sales tax configuration.",
  "source": {
    "own": "This organization's own settings apply, effective from",
    "inherited": "Settings inherited from {{owner}} apply, effective from"
  },
  "outcome": {
    "notCharged": "BC PST, Manitoba RST and Saskatchewan PST are not charged",
    "chargedNow": "BC PST, Manitoba RST and Saskatchewan PST are currently charged",
    "basedOnOwnSetting": ", based on the \"Allow Charge PST\" setting on the",
    "feeSettingsPage": "Fee settings page",
    "basedOnOwnerSetting": ", based on {{owner}}'s \"Allow Charge PST\" setting.",
    "setUpCallToAction": "Choose your taxes and save to set this up.",
    "confirmCallToAction": "Save to confirm or change this."
  },
  "table": {
    "columns": {
      "province": "Province",
      "gst": "GST",
      "hst": "HST",
      "qst": "QST",
      "bcPst": "BC PST",
      "mbRst": "MB RST",
      "skPst": "SK PST"
    },
    "alwaysCharged": "Always charged",
    "charged": "Charged",
    "notCharged": "Not charged",
    "ratesNote": "Current rates, shown for reference. Rates are managed by OneVest."
  },
  "readOnly": {
    "missingPermission": "You can view sales tax settings but not change them."
  },
  "edit": {
    "save": "Save",
    "discard": "Discard"
  },
  "dateNote": {
    "today": "Applies to the whole current billing cycle. Bills already calculated don't change."
  },
  "saveDialog": {
    "title": "Save sales tax settings",
    "newRevision": "These settings take effect today, {{date}}.",
    "correction": "This replaces the settings already saved for today, {{date}}. The original is kept for audit.",
    "confirm": "Save",
    "cancel": "Cancel"
  },
  "saveNotice": {
    "conflictBeforeReload": "Someone else saved a setting for this date while you were editing.",
    "reload": "Reload",
    "conflictAfterReload": "to get the latest; your choices are kept.",
    "reloaded": "Reloaded. Your choices are kept; review them and save again.",
    "reloadFailed": "Saved, but the latest settings could not be loaded."
  },
  "saveError": "Couldn't save the sales tax settings.",
  "sync": {
    "applying": "Applying your change. Fees use the previous setting until this finishes.",
    "notReached": "This change hasn't reached billing yet. Fees use the setting shown below until it does. If this persists, contact support.",
    "notReachedViewed": "A recent inheritance change for {{viewed}} hasn't reached billing yet. Fees use the setting shown below until it does. If this persists, contact support."
  },
  "inherit": {
    "label": "Inherit from parent",
    "stopped": "Stopped inheriting. This organization's own settings apply again (or the legacy switch, if none were saved).",
    "hint": {
      "unsavedChanges": "Save or discard your changes first",
      "missingOrganizationWrite": "You need permission to edit organization settings to change this.",
      "missingOrganizationRead": "You need permission to view organization settings to change this.",
      "orgFlagUnconfirmed": "Couldn't confirm whether this organization inherits from its parent."
    }
  }
}
